export default __webpack_public_path__ + "static/media/subtle-grey.4035b78a.png";